import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import connect from "react-redux/es/connect/connect";
import actions from "../../actions";
import {getAllTourPopups, getContent, getNext, getAuto, getLocalRead, setLocalRead} from "../../helpers/popupHelper";
import {__} from "i18n-for-browser";
import CloseIcon from "../../assets/img/close.png";

const { updatePopups } = actions.popup;

class GlobalPopup extends Component {
  static propTypes = {
    id: PropTypes.string,
    elementFocus: PropTypes.string
  };
  static defaultProps = {
    popupId: '',
    elementFocus: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      history: [props.popupState.popupId],
      count: null,
      cur: 1,
    };
    this.closePopup = this.closePopup.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    document.body.classList.add('noScroll');
    document.addEventListener("keydown", this.handleKeyPress);
    document.addEventListener('click', this.handleClick);

    if (this.state.count === null) {
      const first = this.props.popupState.popupId;
      const {popupState} = this.props;
      const tourCount = getAllTourPopups(first, popupState.tutorial);
      this.setState({
        history: [popupState.popupId],
        count: tourCount,
        desktop: popupState.isDesktop || false,
        oneTimePopup: getAuto(popupState.popupId),
        localRead: getLocalRead(popupState.popupId),
        tutorial: popupState.tutorial
      });

    }
  }

  componentWillUnmount() {
    document.body.classList.remove('noScroll');
    document.removeEventListener("keydown", this.handleKeyPress);
    document.removeEventListener('click', this.handleClick);
    if(this.state.oneTimePopup) setLocalRead(this.state.history[0]);
  }

  handleClick(event) {
    if (this.state.hide) {return;}
    if (
      document.getElementsByClassName('popup').length &&
      !document.getElementsByClassName('popup')[0].contains(event.target) &&
      !event.target.classList.contains("popupControl") &&
      this.props.popupState.closeable
    ){
      this.closePopup();
    }
  }

  handleKeyPress(event) {
    if (event.keyCode === 27) {
      if (this.props.popupState.closeable) {
        this.closePopup();
      }
    }
  }

  /**
   * Method to show next popup
   */
  showNext = async (ev, nextId) => {
    const { state, props } = this;
    const { dispatch } = props;

    let cur = state.cur;
    let stateHistory = state.history;
    stateHistory.push(nextId);
    cur++;

    dispatch(updatePopups({
      popupId: nextId,
    }));

    this.setState({
      history: stateHistory,
      cur: cur
    });
  };

  /**
   * Method to show previous popup
   */
  showPrev = (ev) => {
    const { state, props } = this;
    const { dispatch } = props;

    let cur = state.cur;
    let stateHistory = state.history;

    stateHistory.pop();
    --cur;

    dispatch(updatePopups({
      popupId: stateHistory[stateHistory.length - 1],
    }));

    this.setState({
      history: stateHistory,
      cur: cur
    });
  };

  /**
   * Method to close the current pop-up and reset the Popup state
   * @returns {*}
   */
  closePopup() {
    const { dispatch } = this.props;
    dispatch(updatePopups({
      popupId: null,
      closeable: true,
    }));

    this.setState({
      history: [],
      count: null,
      cur: 1,
    });
  }

  render() {
    const { props, showPrev, showNext, state  } = this;
    const { popupState, gameState } = props;

    const { popupId, closeable } = popupState;
    const isPortal = window.location.pathname.indexOf('portal') !== -1;

    if ( state.oneTimePopup && state.localRead ) this.closePopup();

    let nextId = '';
    if (popupId) {
      nextId = getNext(popupId, state.tutorial);
    }
    if(this.state.hide) { return null; }
    return (
      <div className={"popup-parent " + (popupId ? 'active' : '') + (isPortal ? ' is-portal' : '')}>
        <div className={'popup-page-container'}>
          <div className={'popup-spacer-desktop'}/>
          <div className={'popup-holder'}>
            <div className={'popup-holder-inner'}>
              <div className="popup" ref={node => this.node = node}>

                { (!state.count && closeable) || (state.count === 1 && state.count === state.cur) ? (
                  <div onClick={this.closePopup} className="top-right-close-button close-button">
                    <span className="close-icon">
                      <img src={CloseIcon} height='15' alt=''/>
                    </span>
                  </div>
                ) : null }

                <Fragment>
                  <div className="popup-content" dangerouslySetInnerHTML={{ __html: getContent(popupId, gameState.language) }} />

                  { state.count >= 1 ? (
                    <div className="popup-navigation">
                      {nextId ? (
                        <button className={'tut-next'} onClick={(ev) => { showNext(ev, nextId)}}>
                          <span className="popupControl">{__('sim_volgende_button')}</span>
                        </button>
                      ) : null }
                      { state.count > 1 && state.count === state.cur ? (
                        <button className={'tut-close'} onClick={this.closePopup}>
                          <span className="popupControl">{__('sim_aan_de_slag_button')}</span>
                        </button>
                      ) : null }
                      { state.count > 1 ? (
                        <div className={'tutorial-counter'}>
                          <span className="popupControl">{state.cur}</span>
                          /
                          <span className="popupControl">{state.count}</span>
                        </div>
                      ) : null }

                      {state.history.length > 1 ? (
                        <button className={"button--white tut-prev"} onClick={(ev) => { showPrev(ev); }}>
                          <span className="popupControl">{__('sim_vorige_button')}</span>
                        </button>
                      ) : null }

                    </div>
                  ) : null }
                </Fragment>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default withRouter(connect(state => state)(GlobalPopup));



// WEBPACK FOOTER //
// ./src/components/elements/GlobalPopup.js